<template>
    <ui-modal
        :icon-circle="true"
        :load="loader.voucher"
        icon="fal fa-print"
        name="print-customer-accreditation">

        <div class="container-print-customer-accreditation-header">
            <div class="icon">
                <em class="fa fa-times" @click="closeHandler" />
            </div>

            <div class="title">Imprimir Credenciamento</div>
        </div>

        <section class="qrcode">
            <ui-accreditation-voucher :data="deal" @loading="loader.voucher = $event" />
        </section>


        <div class="button-accreditation">
            <ui-button :disabled="!deal" design="primary md mw-150" @click="printHandler">
                Imprimir
            </ui-button>
        </div>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
    import { uiAccreditationVoucher } from '@/components/ui-facilita/launch'

    import { launchDay } from '@/services/axios'

    import { mapGetters } from 'vuex'

    const defaultLoader = () => ({
        voucher: false,
        print: false
    })

    export default {
        name: 'ui-print-customer-accreditation-modal',

        components: {
            uiModal,
            uiButton,
            uiAccreditationVoucher
        },

        data() {
            return {
                deal: null,
                loader: { ...defaultLoader() }
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                definitions: 'getDefinitions'
            })
        },

        created() {
            this.$root.$on('modal-open-print-customer-accreditation', payload => {
                this.deal = { ...payload }
            })
        },

        beforeDestroy() {
            this.$root.$off('modal-open-print-customer-accreditation')
        },

        methods: {
            /**
             * Event handler que trata o evento de quando o fechamento do modal é requerido, de
             * modo a limpar os dados e fechar o modal
             */
            closeHandler() {
                this.deal = null
                this.$root.$emit('modal-close-print-customer-accreditation')
            },
            /**
             * Trata o evento de quando a impressão do comprovante de credenciamento é requerida
             */
            printHandler() {
                this.loader.print = true

                // Pega todas as tags style para adicionar as classes CSS no modal
                let stylesHtml = '';
                for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                    stylesHtml += node.outerHTML
                }
                stylesHtml += `
                    <style type="text/css">
                        @media print {
                            @page {
                                size: landscape !important;
                                margin: 0px;
                            }
                        }
                    </style>
                `

                const printWindow = window.open('', 'PRINT', 'height=600,width=400')
                printWindow.document.write(`
                    <html>
                        <head>
                            ${stylesHtml}
                            <title>Imprimir Comprovante</title>
                        </head>
                        <body>
                            ${document.getElementById('accreditation_voucher').innerHTML}
                        </body>
                    </html>
                `)

                printWindow.document.close() // Necessary for IE >= 10
                printWindow.focus() // Necessary for IE >= 10*/

                // Cadastra o checkin para o controle de credenciamento
				const params = {
                    model: 'Deal_Main',
                    id: this.deal.id,
                    points_id: this.definitions.launchday_point_id
                }
                launchDay.create('checkin', params)
                    .then(response => {
                        this.$toastr.s(response.data.msg)
						this.loader.print = false
						printWindow.print()
						printWindow.close()
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>